import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    timeSign,
    firstTime,
    signer,
    supplementaryForThe,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    taxAgentName,
    taxAgentId,
    taxCalculationPeriodEnd,
    settlementCase,
  },
} = checkout;

const validation = Yup.object().shape({
  [taxAgentName.name]: Yup.string().notRequired(taxAgentName.errorMsg),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [settlementCase.name]: Yup.string().required(taxpayerName.errorMsg),

  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxCalculationPeriodEnd.name]: Yup.number().required(taxCalculationPeriodEnd.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),

  [taxAgentId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgentId.invalidMsg)
    .notRequired(taxAgentId.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),

  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
});

export default validation;
